import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=0b792c4e&scoped=true&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=0b792c4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b792c4e",
  null
  
)

export default component.exports